import { SquareDashed } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgUncheckAll = mkIcon(SquareDashed);